import { render, staticRenderFns } from "./Solucoes.vue?vue&type=template&id=206dc2c9&scoped=true&lang=pug&"
import script from "./Solucoes.vue?vue&type=script&lang=js&"
export * from "./Solucoes.vue?vue&type=script&lang=js&"
import style0 from "./Solucoes.styl?vue&type=style&index=0&id=206dc2c9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206dc2c9",
  null
  
)

export default component.exports